import Controller, { OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../BaseController';
import { CheckupItemsListAliases, FragmentNames } from '../../codegen';
import './checkup-list-controller.css';
import { Inject } from '@odinjs/odin';
import { FetchAPI } from '@philips-internal/oswald-ui-components';
import { Value } from '@philips-internal/oswald-ui-core';

@Controller({ component: CheckupItemsListAliases.LAYOUT_CHECKUP_ITEMS_LIST, fragment: FragmentNames.CHECKUP_ITEMS_LIST })
export default class CheckupListController extends BaseController {

  @Inject(CheckupItemsListAliases.FETCH_CHECKUP_ITEMS_LIST)
    fetchCheckupItemsListApi!: FetchAPI;

  @OnMount({ target: CheckupItemsListAliases.FETCH_CHECKUP_ITEMS_LIST })
  handleMount(): void {

    const personCode = this.context.get('personCode') as string;
    const checkupCode = this.context.get('checkupCode') as string;
    const type = this.context.get('checkupType') as string;

    const parameters = {
      checkupCode: checkupCode,
      personCode: personCode,
      type: type,
    } as Record<string, Value>;

    this.fetchCheckupItemsListApi.setParameters(parameters);

    this.fetchCheckupItemsListApi.forceFetch();
  }
}
